import React, {useState} from 'react';
// import React, {useState, useEffect} from 'react';
import PageInfoStore from './flux/PageInfoStore';
// import useWindowSize from './hooks/windowSize';
import usePageSize from './hooks/usePageSize';
import usePageScroll from './hooks/usePageScroll';

export default function Diagnostic() {
  const diagnosticVisible = false;
  const pageSize = usePageSize();
  const pageScroll = usePageScroll();
  const lastPosition = PageInfoStore.getLastScrollPos();
  const [showDiagnostic, setShowDiagnostic] = useState(true);
  PageInfoStore.setScrollDirection(pageScroll);
  PageInfoStore.setLastScrollPos(pageScroll);
  const scrollDirection = PageInfoStore.getScrollDirection();

  function toggleDiagnostic() {
    showDiagnostic ? setShowDiagnostic(false) : setShowDiagnostic(true);
  }

  function renderDiagnostics() {
    return (
      <div className="slDiagnostic">
        <div className={showDiagnostic ? 'show' : 'hide'}>
          <span className="diagnostic-header" />
          <span
            className={showDiagnostic ? 'close-button toggle' : 'open-button toggle'}
            onClick={toggleDiagnostic}
          />

          <span className="info">
            <p>window w: {pageSize.width} </p>
            <p>window h: {pageSize.height} </p>
            <p>scroll y: {pageScroll} </p>
            <p>last: {lastPosition}</p>
            <p>scroll: {scrollDirection}</p>
            <p>mobile: {pageSize.width < 990 ? 'true' : 'false'} </p>
          </span>
          
        </div>
      </div>
    )
  }

  return diagnosticVisible ? renderDiagnostics() : false
  
}